// extracted by mini-css-extract-plugin
export var addressFields = "_p8-0";
export var animationContainer = "_p8-1";
export var footer = "_p8-2";
export var lineItems = "_p8-3";
export var modalContent = "_p8-4";
export var orderName = "_p8-5";
export var strong = "_p8-6";
export var warning = "_p8-7";